import Styled from '@components/common/Loader.styled';

function Loader() {
  return (
    <Styled.Wrapper>
      <Styled.Dot />
      <Styled.Dot />
      <Styled.Dot />
    </Styled.Wrapper>
  );
}

export default Loader;
